module.exports = "<svg viewBox=\"0 0 32.2 32\"><path fill=\"#231F20\" d=\"M31.2 32H1c-.6 0-1-.4-1-1V4.8c0-.6.4-1 1-1h30.2c.6 0 1 .4 1 1V31c0 .6-.5 1-1 1zM2 30h28.2V5.8H2V30z\"></path><path fill=\"#231F20\" d=\"M31.2 15.1H1c-.6 0-1-.4-1-1s.4-1 1-1h30.2c.6 0 1 .4 1 1s-.5 1-1 1zM9.6 9.7c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v7.7c0 .6-.5 1-1 1zm13 0c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1s1 .4 1 1v7.7c0 .6-.4 1-1 1z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/calendar.svg
// module id = 295
// module chunks = 1